import { useCallback } from "react";
import { Modal } from "antd";
import { getHost } from "./getHost";

export interface ConfirmPayload {
  title: string;
  content: string;
  okText?: string;
  cancelText?: string;
  variant?: "primary" | "danger";
}

export type ConfirmFn = (payload: ConfirmPayload) => Promise<boolean>;

export function useHostConfirm(): ConfirmFn {
  return useCallback((payload) => {
    const host = getHost();
    if (host?.showConfirmModal) return host.showConfirmModal(payload);

    return new Promise<boolean>((resolve) => {
      Modal.confirm({
        title: payload.title,
        content: payload.content,
        okText: payload.okText,
        cancelText: payload.cancelText,
        okButtonProps: payload.variant === "danger" ? { danger: true } : undefined,
        onOk: () => resolve(true),
        onCancel: () => resolve(false),
      });
    });
  }, []);
}
